import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'd2d-root-skeleton-layout',
  imports: [RouterOutlet, Skeleton],
  templateUrl: './root-skeleton-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './root-skeleton-layout.component.scss',
})
export class RootSkeletonLayoutComponent {}
